import styled from '@emotion/styled'
import ReactMarkdown from 'react-markdown'

import { getArcadeLinkStyles, getMarkdownLinkStyle, PaddingInset, Text } from '@cash-design-system/react'
import { FormBlockerElementLegalTextElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { useArcadeMigrationFeatureFlag } from '@cash-web/shared-data-access-arcade-migration'

const MarkdownContainer = styled.div`
  color: ${props => props.theme.colors.tertiaryLabel};
  ${props => getMarkdownLinkStyle(props.theme)}
`

const ArcadeMarkdownText = styled(Text)`
  * {
    font-family: 'Cash Sans Mono', monospace;
  }

  a {
    ${props => getArcadeLinkStyles(props.theme)}
  }
`

export const LegalTextElement = ({ text }: FormBlockerElementLegalTextElement) => {
  const isArcadeMigrationEnabled = useArcadeMigrationFeatureFlag('apps')

  if (!text) {
    throw new Error('No text for LegalTextElement')
  }

  if (isArcadeMigrationEnabled)
    return (
      <ArcadeMarkdownText textAlign="center" color="textStandard" typography="bodyXSmall">
        <ReactMarkdown children={text} />
      </ArcadeMarkdownText>
    )
  return (
    <PaddingInset>
      <MarkdownContainer>
        <ReactMarkdown children={text} />
      </MarkdownContainer>
    </PaddingInset>
  )
}
